module.exports = __webpack_public_path__ + "media/images/remote-learning-star-01-71bf15701c3ca884823080edcfcb4def1ea219d50678a770cb1a9ce1642d9ae4.svg";